const getLocale = locale => {
    return locale ? locale : 'nb-NO';
}
const getDateString = (source, locale) => {
    return new Date(source.substring(0, 19) + 'Z').toLocaleString(getLocale(locale), { dateStyle: 'short' });
}
const getShortTimeString = (source, locale) => {
    return new Date(source.substring(0, 19) + 'Z').toLocaleString(getLocale(locale), { hour: '2-digit', minute: '2-digit' });
}
const getTimeString = (source, locale) => {
    return new Date(source.substring(0, 19) + 'Z').toLocaleString(getLocale(locale), { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}
const getDateTimeString = (source, locale) => {
    try {
        return getDateString(source, locale) + ' ' + getTimeString(source, locale);
    }
    catch {
        return null;
    }
}
const getShortDateTimeString = (source, locale) => {
    try {
        return getDateString(source, locale) + ' ' + getShortTimeString(source, locale);
    } catch {
        return null;
    }
}
const getWeekdayString = (source, locale) => {
    try {
        return new Date(source).toLocaleString(getLocale(locale), { weekday: 'long' });
    } catch {
        return null;
    }
}
const formatNumber = (source, locale) => {
    try {
        return Number(source).toLocaleString(getLocale(locale), { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch {
        return null;
    }
}
const addDays = (source, days)=>{
    let date = new Date(source).getTime() + days * 1000 * 60 * 60 * 24;
    return new Date(date).toISOString();
}
const getDifferenceString = (from, to) => {

    const seconds = Math.floor((new Date(from) - new Date(to)) / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const s = seconds % 60;
    const m = minutes % 60;
    const h = hours % 24;
    return { days: days, hours:h, minutes:m, seconds:s, total_seconds: seconds};
  };
//timeZone: 'Europe/Oslo'
const convertTimeZone=(date, time_zone)=>
{
    let locale = 'en-US'
    let dateString = date.toLocaleString(locale, {day: '2-digit',   hour12: false, timeZone: time_zone });
    let monthString = date.toLocaleString(locale, {month: '2-digit',   hour12: false, timeZone: time_zone });
    let yearString = date.toLocaleString(locale, {year: 'numeric',   hour12: false, timeZone: time_zone });
    let result = yearString + '-' + monthString + '-' + dateString;
    result = result.replaceAll('.', '')
    return result;  
}
export default {
    getDateTimeString, getShortDateTimeString, getWeekdayString, formatNumber, getDifferenceString, addDays, convertTimeZone
}